export default __webpack_public_path__ + "static/media/mutual-ic-photo.1f45fbd5.svg";